import produce from 'immer'

import {
  USERS_ACCOUNT_MAPPING_LOAD,
  USERS_ACCOUNT_MAPPING_LOADED,
  USERS_ACCOUNT_MAPPING_LOAD_FAILURE
} from './actions'

const initialState = { loading: false, error: null, users: {} }

export const reducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case USERS_ACCOUNT_MAPPING_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case USERS_ACCOUNT_MAPPING_LOADED: {
        const { userId, userDetails } = action
        draft.loading = false
        draft.error = null
        draft.users[userId] = userDetails
        return
      }
      case USERS_ACCOUNT_MAPPING_LOAD_FAILURE: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
}
